import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import LoadingEllipsis from './shared/loading-ellipsis/LoadingEllipsis';
import Checkbox from '@material-ui/core/Checkbox';
import WarningIcon from '@material-ui/icons/WarningRounded';
import * as qs from 'querystring';
import axios from 'axios';
import styles from '../styles/common';

const UpdateButton = withStyles(() => ({
  root: {
    color: '#FFFFFF',
    backgroundColor: '#FF6800',
    float: 'right'
  }
}))(Button);

const CancelButton = withStyles(() => ({
  root: {
    border: '1px solid #9B9B9B',
    borderRadius: '4.5px',
    color: '#9B9B9B',
    backgroundColor: '#FFFFFF'
  }
}))(Button);

const ShowFormWarning = props => {
  const { form_warn, classes } = props;
  if (form_warn) {
    return (
      <div>
        <WarningIcon
          className={classes.warningIconSingleLine}
          style={{ color: 'darkorange' }}
        />
        <Typography className={classes.warnText}>
          Choose at least one group or unsubscribe from all.
        </Typography>
      </div>
    );
  } else {
    return '';
  }
};

class Optout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      redirect_url: null,
      client_id: '',
      org_id: '',
      campaign_id: '',
      broadcast_id: '',
      contact_id: '',
      user_data: {},
      unsubscribe_all: false,
      post_error: false,
      form_warn: false,
      get_error: false,
      error_response: '',
      subscriptions: [],
      user_found: false,
      org_address: {},
      card_content_text: '',
      disable_cardcontent: false
    };
  }

  async cancelSubsPreferences() {
    await this.setState({
      disable_cardcontent: true,
      card_content_text:
        'Your request has been cancelled and no action has been taken on your behalf.'
    });
  }

  componentDidMount() {
    this.prepare_unsubscribe();
    document.body.style = 'background: #444;';
  }

  async prepare_unsubscribe() {
    const url_string = this.props.location.search.split('?')[1];
    const query_obj = await qs.parse(url_string);
    const broadcast_id = query_obj['mid'].split('-')[0];
    const contact_id = query_obj['mid'].split('-')[1];

    const params = {
      broadcast_id: broadcast_id,
      contact_id: contact_id
    };
    let user_data = await axios('/optout/get_client_info', {
      params: params
    }).catch(error => {
      this.setState({
        get_error: true,
        error_response: error.response.data,
        loading: false
      });
    });

    if (!this.state.get_error) {
      if (user_data['data']['email']) {
        let user_obj = user_data['data'];
        this.setState({
          user_data: user_obj,
          client_id: user_obj['client_id'],
          org_id: user_obj['org_id'],
          campaign_id: user_obj['campaign_id'],
          broadcast_id: broadcast_id,
          contact_id: contact_id,
          loading: false,
          subscriptions: user_obj['subscriptions'],
          user_found: true,
          unsubscribe_all: user_obj['unsubscribe_all'],
          org_address: user_obj['org_address']
        });
      } else {
        this.setState({
          user_found: false,
          loading: false
        });
      }
    }
  }

  async updateSubsPreferences() {
    const {
      org_id,
      client_id,
      campaign_id,
      broadcast_id,
      contact_id,
      user_data,
      subscriptions,
      unsubscribe_all
    } = this.state;
    let user_obj = Object.assign({}, user_data);
    user_obj['subscriptions'] = subscriptions;
    const optout_obj = {
      org_id: org_id,
      client_id: client_id,
      campaign_id: campaign_id,
      broadcast_id: broadcast_id,
      contact_id: contact_id,
      subscriptions: subscriptions,
      unsubscribe_all: unsubscribe_all,
      user_data: user_obj
    };

    const active_subscription_list = subscriptions.filter(
      subscription => subscription.subscribed === true
    );

    if (!unsubscribe_all && (active_subscription_list.length === 0 && subscriptions.length > 0)) {
      this.setState({
        form_warn: true
      });
    } else {
      this.setState({
        loading: true
      });

      const unsubscribe_response = await axios
        .post('/optout/update_subscriptions', optout_obj)
        .catch(error => {
          if (error.response) {
            this.setState({
              post_error: true,
              error_response: error.response.data
            });
            setTimeout(() => {
              this.setState({
                post_error: false,
                loading: true
              });
              this.prepare_unsubscribe();
            }, 5000);
          }
        });

      if (unsubscribe_response && unsubscribe_response.status === 200) {
        this.setState({
          loading: false,
          disable_cardcontent: true,
          card_content_text: 'Your subscription preferences have been updated.'
        });
      } else {
        this.setState({
          loading: false,
          post_error: true
        });
      }
    }
  }

  handle_toggle = index => () => {
    const { subscriptions } = this.state;
    let new_subscribe = !subscriptions[index]['subscribed'];
    let new_subscriptions = [];
    subscriptions.forEach(sub => {
      new_subscriptions.push(sub);
    });
    new_subscriptions[index]['subscribed'] = new_subscribe;
    this.setState({
      subscriptions: new_subscriptions
    });
  };

  all_subscription_toggle = () => () => {
    const { unsubscribe_all, subscriptions } = this.state;
    let new_subscriptions = [];
    let new_state = {};
    if (!unsubscribe_all) {
      subscriptions.forEach(subscription => {
        let temp_sub = Object.assign({}, subscription);
        temp_sub['subscribed'] = false;
        new_subscriptions.push(temp_sub);
      });
      let new_unsubscribe_all = !unsubscribe_all;
      new_state = {
        unsubscribe_all: new_unsubscribe_all,
        subscriptions: new_subscriptions
      };
    } else {
      let new_unsubscribe_all = !unsubscribe_all;
      new_state = {
        unsubscribe_all: new_unsubscribe_all
      };
    }
    this.setState(new_state);
  };

  shouldComponentUpdate(nextProps, nextState) {
    // Will not trigger render() if returns false
    if (
      this.state.loading !== nextState.loading ||
      this.state.unsubscribe_all !== nextState.unsubscribe_all ||
      this.state.post_error !== nextState.post_error ||
      this.state.get_error !== nextState.get_error ||
      this.state.subscriptions !== nextState.subscriptions ||
      this.state.disable_cardcontent !== nextState.disable_cardcontent ||
      this.state.form_warn !== nextState.form_warn
    ) {
      return true;
    } else {
      return false;
    }
  }

  render() {
    const { classes } = this.props;
    const {
      loading,
      user_data,
      subscriptions,
      get_error,
      post_error,
      unsubscribe_all,
      user_found,
      org_address
    } = this.state;
    // hacks starts here
    if (user_data.account_name) {
      document.title = `${user_data.account_name} Email Preferences`;
    } else {
      document.title = `Email Preferences`;
    }
    // hacks ends here

    return (
      <div>
        {loading ? (
          <div className={classes.loadingEllipsisWrapper}>
            <LoadingEllipsis />
          </div>
        ) : get_error ? (
          <Typography className={classes.typographyclr}>
            We were unable to load your subscription preferences. Please try
            again.
          </Typography>
        ) : post_error ? (
          <Typography className={classes.typographyclr}>
            We were unable to process your opt-out request. Please try again.
            You will be redirected to the previous page.
          </Typography>
        ) : user_found ? (
          <div>
            <Card className={classes.card}>
              <CardContent className={classes.content}>
                <Typography
                  className={classes.heading}
                  variant="h1"
                  gutterBottom
                  align="center"
                >
                  SUBSCRIPTION PREFERENCES
                </Typography>
                <Divider className={classes.divider} light />
                {this.state.disable_cardcontent ? (
                  <div>
                    <Typography className={classes.thankyoutext}>
                      Thank you!
                    </Typography>
                    <Typography className={classes.card_content_text}>
                      {this.state.card_content_text}
                    </Typography>
                  </div>
                ) : (
                  <div>
                    {subscriptions.length > 0 ? (
                      <div>
                        <ShowFormWarning
                          form_warn={this.state.form_warn}
                          classes={classes}
                        />
                        <Typography
                          className={classes.label}
                          variant={'body2'}
                          gutterBottom
                          align="center"
                        >
                          Please select what types of email you would like to
                          receive from {user_data.account_name}:
                        </Typography>
                        <List>
                          {subscriptions.map((subscription, index) => (
                            <ListItem
                              key={index}
                              dense
                              button
                              disabled={unsubscribe_all}
                              onClick={this.handle_toggle(index)}
                              className={classes.customlistItem}
                            >
                              <Checkbox
                                className={classes.chckbox}
                                checked={subscription.subscribed}
                              />
                              <ListItemText
                                primary={
                                  <Typography
                                    type="body2"
                                    className={classes.listitemcss}
                                  >
                                    {subscription.label}
                                  </Typography>
                                }
                                className={classes.listitemtext}
                              />
                            </ListItem>
                          ))}
                        </List>
                        <Divider className={classes.divider} light />
                        <Typography
                          className={classes.unsubscribechckboxcaption}
                          gutterBottom
                        >
                          You can also opt to unsubscribe from all emails:
                        </Typography>
                      </div>
                    ) : (
                      ''
                    )}
                    <Typography
                      className={classes.unsubscribechckbox}
                      variant="caption"
                    >
                      <Checkbox
                        inputProps={{
                          'aria-label': 'Checkbox A',
                        }}
                        className={classes.chckbox}
                        checked={unsubscribe_all}
                        onChange={this.all_subscription_toggle()}
                      />
                      I wish to unsubscribe from all future emails
                    </Typography>
                    <Divider className={classes.divider} light />
                    <CancelButton
                      variant="contained"
                      onClick={() => this.cancelSubsPreferences()}
                    >
                      CANCEL
                    </CancelButton>
                    <UpdateButton
                      variant="contained"
                      onClick={() => this.updateSubsPreferences()}
                    >
                      UPDATE
                    </UpdateButton>
                  </div>
                )}
              </CardContent>
            </Card>
            {org_address['city'] &&
            org_address['state'] &&
            org_address['zipcode'] ? (
                <div>
                  <Typography variant="caption" className={classes.footertext}>
                    {user_data.account_name}
                  </Typography>
                  <Typography variant="caption" className={classes.footertext}>
                    {org_address['addr1']}
                    {org_address['addr1'] && org_address['addr2'] &&
                      ', ' + org_address['addr2']}
                  </Typography>
                  <Typography variant="caption" className={classes.footertext}>
                    {org_address['city']}, {org_address['state']}{' '}
                    {org_address['zipcode']}
                  </Typography>
                </div>
              ) : null}
          </div>
        ) : (
          <Typography>Requested User not found</Typography>
        )}
      </div>
    );
  }
}

Optout.propTypes = {
  location: PropTypes.object,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Optout);



// WEBPACK FOOTER //
// ./src/client/views/optout.js